import { Box, Stack, useTheme } from "@mui/material";
import FooterLayout from "../footer/footerLayout";
import NavigationLayout from "../navigation/navigationLayout";
import CareersHero from "./careersHero";
import Perks from "./perks";
import InterviewProcess from "./interviewProcess";
import JobOpenings from "./jobOpenings";
import { useEffect } from "react";

const CareersLayout = () => {
    const theme = useTheme();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <NavigationLayout />

            <Box
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    pt: {xs: 15, md: 20, lg: 25}
                }}
            >
                <CareersHero />

                <Perks />

                <InterviewProcess />

                <JobOpenings />
            </Box>

            <FooterLayout />
        </>
    );
}

export default CareersLayout;